import { AbstractControl } from '@angular/forms';

export function CountrySelect(control: AbstractControl): { [key: string]: string } | null {
  if (control.value === '' || control.value === 'undefined') {
     return {'country': 'Not Selected'};
  } else {
      return null;
  }
}
